const state = {
  roleLabels: [
    {
      name: '總公司',
      value: '0',
    },
    {
      name: '經銷商',
      value: '1',
    },
  ],
  roleLabel: '1',
  companies: [],
  company_id: '',
};

const mutations = {
  setRoleLabel(state, payload) {
    return (state.roleLabel = payload);
  },
  setCompanies(state, payload) {
    state.companies = payload;
  },
  setCompanyId(state, payload) {
    state.company_id = payload;
  },
  setUserRoleLabel(state, payload) {
    state.userRoleLabel = payload;
    if (payload === '1') {
      state.roleLabels = [
        {
          name: '經銷商',
          value: '1',
        },
      ];
    }
  },
};

const getters = {
  roleLabels: (state) => state.roleLabels,
  roleLabel: (state) => state.roleLabel,
  companies: (state) => state.companies,
  company_id: (state) => state.company_id,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
